import { z } from 'zod';

import { LosId, UserId } from '../../BrandedIds';
import { zodTemporalInstant } from '../../Temporal';

export const ExportablePointOfContact = z
  .object({
    loanId: LosId,
    userId: UserId,
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'PointOfContact' });
export type ExportablePointOfContact = z.infer<typeof ExportablePointOfContact>;
